<div
  class="flex flex-col gap-(--summarycard-gap) px-(--summarycard-padding-x) py-(--summarycard-padding-y) rounded-(--summarycard-border-radius) border-[0.5px] border-(--summarycard-border-color) bg-(--summarycard-background) font-(--summarycard-font-family)"
>
  <app-dynamic
    componentName="DynamicText"
    [props]="{ config: titleConfig() }"
  />

  @if (supportingText1Config(); as config) {
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config }"
    />
  }

  @if (supportingText2Config(); as config) {
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config }"
    />
  }

  @if (buttons().length > 0) {
    <div class="flex flex-col gap-3 w-full">
      @for (button of buttons(); track $index) {
        <app-dynamic
          componentName="Button"
          [props]="{ config: button, disabled: disabled() }"
          (action)="onButtonClick(button.action)"
        />
      }
    </div>
  }
</div>
